import { css } from 'styled-components';
import { mixinClearfix, mixinThumbnailLine } from '@/public/template/common/css/setting/mixin';
import { fontSize, size } from '@/public/template/common/css/setting/variable';

export const adPlainStyle = css`
  /* AD YDN plain-html */
  .yads_ad_pc,
  .yads_ad_pc_res_s,
  .yads_ad_pc_rank,
  .yads_ad_pc_rank_res_s {
    position: relative;
    margin-bottom: 15px;
    border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};

    .yads_ad_item,
    .yads_ad_item_res_s {
      display: block;
      padding: 8px 0 24px;

      &:hover {
        text-decoration: none;
        background: ${props => props.theme.news.palette.bg_hover_subColumn_pc};

        .yads_ad_title_res_s {
          text-decoration: underline;
        }
      }

      &::after {
        ${mixinClearfix}
      }
    }

    .yads_ad_img,
    .yads_ad_img_res_s {
      float: right;
      width: ${size.thumbnail_small_pc};
      height: ${size.thumbnail_small_pc};
      margin: 0 0 0 8px;

      img {
        max-width: ${size.thumbnail_small_pc};
      }
    }

    .yads_ad_desc,
    .yads_ad_desc_res_s,
    .yads_ad_title,
    .yads_ad_title_res_s {
      font-size: 82.5%;
      word-wrap: break-word;
    }

    .yads_ad_adv,
    .yads_ad_adv_res_s {
      font-size: ${fontSize.px12};
      color: ${props => props.theme.news.palette.text_sub_lv1_common};
    }

    .yads_ad_info,
    .yads_ad_info_res_s {
      position: absolute;
      right: 0;
      bottom: 4px;
      font-size: ${fontSize.px11};
      line-height: 14px;

      a {
        padding: 4px;
        color: ${props => props.theme.news.palette.text_sub_lv2_common};
        &:hover {
          color: ${props => props.theme.news.palette.text_sub_lv2_common};
          text-decoration: none;

          span {
            text-decoration: underline;
          }
        }
        img {
          vertical-align: top;
        }
      }
    }
  }

  .yads_ad_pc_rank,
  .yads_ad_pc_rank_res_s {
    a.yads_ad_item:hover,
    a.yads_ad_item_res_s:hover {
      .yads_ad_title,
      .yads_ad_desc {
        color: ${props => props.theme.news.palette.link_hover_pc};
        text-decoration: underline;
      }
    }

    .yads_ad_item,
    .yads_ad_item_res_s {
      padding: 8px 0 24px 30px;
    }

    .yads_ad_title::before,
    .yads_ad_title_res_s::before {
      position: absolute;
      top: 8px;
      left: 0;
      width: 30px;
      font-size: ${fontSize.px14};
      font-weight: bold;
      line-height: 20px;
      color: ${props => props.theme.news.palette.text_base_common};
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      content: 'PR';
    }
  }

  /* ヤフコメランキングのみの幅調整 */
  .comment {
    .yads_ad_pc_rank,
    .yads_ad_pc_rank_res_s {
      .yads_ad_item,
      .yads_ad_item_res_s {
        padding: 8px 0 24px 50px;
      }

      .yads_ad_title::before,
      .yads_ad_title_res_s::before {
        width: 50px;
      }
    }
  }

  .yads_ad_pc,
  .yads_ad_pc_res_s {
    .yads_ad_title::before,
    .yads_ad_title_res_s::before {
      display: inline-block;
      padding: 0 6px;
      margin-right: 3px;
      font-size: ${fontSize.px11};
      line-height: 14px;
      color: #fff;
      vertical-align: middle;
      content: 'PR';
      background: #717171;
    }
  }

  /* スポコン右カラム plain-html */
  .rma_responsive_small {
    margin-bottom: 16px;
    border-bottom: 1px solid rgb(225 225 225);

    .rma_header {
      padding: 4px;
      font-size: ${fontSize.px14};
      font-weight: bold;
      border-bottom: 1px solid rgb(225 225 225);
    }

    .rma_click_area {
      a {
        display: block;
        padding: 8px 0;

        &:hover {
          text-decoration: none;
          background: ${props => props.theme.news.palette.bg_hover_subColumn_pc};

          .rma_title {
            text-decoration: underline;
          }
        }

        &::after {
          ${mixinClearfix}
        }
      }
    }

    .rma_info {
      line-height: 1.3;
    }

    .rma_img {
      float: right;
      width: ${size.thumbnail_small_pc};
      height: ${size.thumbnail_small_pc};
      margin-left: 10px;
      background-color: ${props => props.theme.news.palette.thumbnail_normal_common};
      background-repeat: no-repeat;
      background-size: contain;
    }

    .rma_title {
      display: inline;
      font-size: ${fontSize.px13};
    }

    .rma_adv {
      display: block;
      padding-top: 4px;
      font-size: ${fontSize.px12};
      color: ${props => props.theme.news.palette.text_sub_lv2_common};
    }

    a:hover .rma_adv {
      text-decoration: none;
    }

    /* 「Yahoo!ニュース タイアップ」という記述は重複しているので、こちらは非表示にする */
    .rma_footer {
      display: none;
    }
  }
`;

export const adFeedStyle = css`
  /* タイムライン型 YDNインフィード広告 */
  .yads_ad_pc_feed,
  .yads_ad_pc_feed_res_s,
  .yads_ad_pc_feed_res_large {
    position: relative;

    a.yads_ad_item:hover,
    a.yads_ad_item_res_s:hover,
    a.yads_ad_item_res_large:hover {
      background-color: ${props => props.theme.news.palette.bg_hover_normal_pc};

      .yads_ad_title,
      .yads_ad_desc {
        color: ${props => props.theme.news.palette.link_hover_pc};
        text-decoration: underline;
      }
    }

    a.yads_ad_item:visited,
    a.yads_ad_item_res_s:visited,
    a.yads_ad_item_res_large:visited {
      color: ${props => props.theme.news.palette.link_visited_pc};
    }

    .yads_ad_item,
    .yads_ad_item_res_s {
      display: flex;
      align-items: center;
      padding: 12px;
      text-decoration: none;

      .yads_ad_img {
        position: relative;
        margin-right: 8px;
        ${mixinThumbnailLine({ width: size.thumbnail_middle_pc, height: size.thumbnail_middle_pc })};

        img {
          max-width: ${size.thumbnail_middle_pc};
          max-height: ${size.thumbnail_middle_pc};
          vertical-align: middle;
        }
      }

      .yads_ad_inner_2,
      .yads_ad_inner_2_res_s {
        flex: 1;
        margin-bottom: 14px;
      }

      .yads_ad_title {
        display: inline;
        line-height: 1.3;
      }

      .yads_ad_desc {
        position: relative;
        display: inline;
        padding: 0 0 0 4px;
        line-height: 1.3;

        &::before {
          display: inline-block;
          padding: 0 4px;
          content: '|';
        }
      }

      .yads_ad_adv {
        margin-top: 4px;
        font-size: ${fontSize.px12};
        color: ${props => props.theme.news.palette.text_sub_lv1_common};
      }
    }

    /* インフィード大 */
    .yads_ad_item_res_large {
      display: flex;
      align-items: center;
      padding: 12px;
      text-decoration: none;

      .yads_ad_img {
        position: relative;
        margin-right: 8px;

        ${mixinThumbnailLine({
          width: size.thumbnail_ad_infeedLarge_width_pc,
          height: size.thumbnail_ad_infeedLarge_height_pc
        })};

        img {
          max-width: ${size.thumbnail_ad_infeedLarge_width_pc};
          max-height: ${size.thumbnail_ad_infeedLarge_height_pc};
          vertical-align: middle;
        }
      }

      .yads_ad_inner_2_res_large {
        flex: 1;
        margin-bottom: 14px;
      }

      .yads_ad_title {
        display: inline;
        line-height: 1.3;
      }

      .yads_ad_adv {
        margin-top: 4px;
        font-size: ${fontSize.px12};
        color: ${props => props.theme.news.palette.text_sub_lv1_common};
      }
    }

    .yads_ad_info {
      position: absolute;
      right: 12px;
      bottom: 12px;
      text-align: right;

      a {
        padding: 0;
        font-size: ${fontSize.px12};
        color: ${props => props.theme.news.palette.text_sub_lv2_common};
        text-decoration: none;

        &:hover {
          color: ${props => props.theme.news.palette.text_sub_lv2_common};
          text-decoration: underline;
        }
      }
      img {
        vertical-align: middle;
      }
    } /* 広告表記 */
  }
`;

export const commentRankingAdOverWriteStyle = css`
  /* ヤフコメランキングの広告のPRの位置を揃えるStyle */
  .yads_ad_pc_rank_res_s {
    .yads_ad_item_res_s {
      padding: 8px 0 24px 50px;
    }
    .yads_ad_title_res_s::before {
      left: 10px;
    }
  }
`;
